import React, { FC } from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import Button from '../core/Button';
import IconButton from '../core/IconButton';
import { IconEdit, IconEye } from '../../icons';

const messages = defineMessages({
  editPlan: {
    id: 'check_in_plan_management.edit_plan_button',
    defaultMessage: 'Edit check-in plan',
  },
  viewPlan: {
    id: 'check_in_plan_management.view_plan_button',
    defaultMessage: 'Inspect check-in plan',
  },
});

interface CheckInPlanListProps {
  plans: CheckInPlan[];
  onClose: () => void;
  isProcessing: boolean;
  onSelect: (id: string) => void;
  onView: (id: string) => void;
  onNewPlan: () => void;
}

const CheckInPlanList: FC<CheckInPlanListProps> = ({
  plans,
  isProcessing,
  onClose,
  onSelect,
  onView,
  onNewPlan,
}) => {
  const intl = useIntl();
  return (
    <>
      <div className="min-h-0 flex-1 overflow-y-auto px-6 pb-5">
        <div className="flex flex-row items-stretch">
          <div className="grow basis-0">
            <ul className="py-2">
              {plans.length === 0 && (
                <li className="relative flex items-center justify-start px-4 py-1">
                  <p className="text-base leading-6">
                    <FormattedMessage
                      id="check_in_plan_management.no_check_in_plans_created"
                      defaultMessage="No check-in plans created."
                    />
                  </p>
                </li>
              )}
              {plans.map((plan) => {
                return (
                  <li
                    key={plan.id}
                    className="relative flex items-center justify-start px-4 py-1"
                  >
                    <span className="mr-2 flex-auto text-base leading-6">
                      {plan.title}
                    </span>
                    <IconButton
                      variant="ghost"
                      icon={<IconEdit />}
                      aria-label={intl.formatMessage(messages.editPlan)}
                      onClick={() => onSelect(plan.id)}
                    />
                    <IconButton
                      variant="ghost"
                      icon={<IconEye />}
                      aria-label={intl.formatMessage(messages.viewPlan)}
                      onClick={() => onView(plan.id)}
                    />
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="flex grow-[2] basis-0 flex-col items-center justify-center border-l border-background-500">
            <p className="text-base leading-6">
              <FormattedMessage
                id="check_in_plan_management.select_plan_to_the_left_or_create_new"
                defaultMessage="Select check-in plan in the left list or create a new plan."
              />
            </p>
            <Button variant="filled" className="mt-4" onClick={onNewPlan}>
              <FormattedMessage
                id="check_in_plan_management.new_check_in_plan"
                defaultMessage="New check-in plan"
              />
            </Button>
          </div>
        </div>
      </div>
      <div className="flex shrink-0 flex-row items-center justify-end p-2">
        <Button variant="outline" loading={isProcessing} onClick={onClose}>
          <FormattedMessage id="close" defaultMessage="Close" />
        </Button>
      </div>
    </>
  );
};

export default CheckInPlanList;
